type Props = {
  data?: string;
  hasBiggerValue: boolean;
  isLoading: boolean;
};

const AdditionalValue = ({ data, hasBiggerValue, isLoading }: Props) => {
  return !isLoading ? (
    <div
      className={
        'font-semibold text-dark-800 ml-0.5 mb-0.5' +
        (hasBiggerValue ? ' text-sm' : ' text-xs')
      }
    >
      {data}
    </div>
  ) : (
    <Fallback />
  );
};

const Fallback = () => {
  return (
    <div className="animate-pulse bg-light-800 rounded-md w-28 h-4 self-stretch"></div>
  );
};

export { AdditionalValue };
